'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _menuStateManager = require('./menuStateManager');

var _menuStateManager2 = _interopRequireDefault(_menuStateManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Common Menu Item
 * @param {jQuery} $object
 * @param {string} activeClass
 * @property {string} title
 * @property {boolean} isActive
 * @property {boolean} toBeRemoved
 * @constructor
 */
/**
 * @module navigation/commonMenuItem
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

function CommonMenuItem($object, activeClass) {
    this.$obj = $object;
    this.activeClass = activeClass;

    this.title = this.getTitle();
    this.isActive = this.$obj.children().hasClass(this.activeClass);
    this.toBeRemoved = false;

    this.stateManager = new _menuStateManager2.default(this);
}

/**
 * Get item title
 * @returns {String}
 */


/**
 * @type {MenuStateManager}
 */
CommonMenuItem.prototype.getTitle = function () {
    return this.$obj.text().trim();
};

/**
 * Get item href
 * @returns {String}
 */
CommonMenuItem.prototype.getHref = function () {
    return this.$obj.children().attr('href');
};

/**
 * Get js classes
 * @returns {Array}
 */
CommonMenuItem.prototype.getJsClasses = function () {
    var aClassList = this.$obj.children().attr('class').split(/\s+/);

    var jsClasses = [];
    aClassList.map(function (item) {
        if (/^js-.*/.test(item)) {
            jsClasses.push(item);
        }
    });

    return jsClasses;
};

/**
 * Get menu item state
 * @public
 * @returns {Object}
 */
CommonMenuItem.prototype.getItemState = function () {
    return this.stateManager.getItemState();
};

/**
 * Set menu item state
 * @public
 * @param {Object} options
 * @returns {CommonMenuItem}
 */
CommonMenuItem.prototype.setItemState = function (options) {
    this.stateManager.setItemState(options);
    return this;
};

/**
 * Clear menu item state
 * @public
 * @returns {CommonMenuItem}
 */
CommonMenuItem.prototype.clearItemState = function () {
    this.stateManager.clearItemState();
    return this;
};

/**
 * Apply changes to DOM
 * @public
 * @protected
 */
CommonMenuItem.prototype.render = function () {
    if (!this.activeClass) {
        throw new Error('Class for active item is undefined!');
    }

    var $innerObj = this.$obj.children();
    if (this.isActive) {
        $innerObj.addClass(this.activeClass);
    } else {
        $innerObj.removeClass(this.activeClass);
    }

    return this;
};

/**
 * @protected
 * @param {string} selector
 * @returns {*}
 */
CommonMenuItem.prototype.hasSelector = function (selector) {
    return this.$obj.children().is(selector);
};

exports.default = CommonMenuItem;


//////////////////
// WEBPACK FOOTER
// ./~/rp-navigation/lib/navigation/commonMenuItem.js
// module id = 389
// module chunks = 0